import { z } from "zod";
import { publicEndpoint } from "~/lib/api/builder";

const fetchRefreshTokenRetryLimit = 3;

export const refresh = publicEndpoint.mutation(
    (refresh_token) => ({
        json: { refresh_token },
        method: "POST",
        retry: fetchRefreshTokenRetryLimit,
        url: "auth/refresh",
    }),
    {
        input: z.string(),
        output: z.object({
            access_token: z.string(),
            refresh_token: z.string(),
            refresh_token_ttl: z.string(),
        }),
    },
);
